export const cilEnvelopeOpen = ["24 24","<path d='M12.872 1.201c-0.242-0.175-0.545-0.279-0.872-0.279s-0.63 0.105-0.876 0.282l0.004-0.003-10.378 7.413v14.636h22.5v-14.636zM21.75 18.876l-5.814-3.737 5.814-4.522zM12 2.422l9.301 6.644-6.703 5.213-2.598-1.67-2.598 1.67-6.703-5.213zM2.25 10.617l5.814 4.522-5.814 3.737zM21.75 21.75h-19.5v-1.091l9.75-6.268 9.75 6.268z'></path>"]


//////////////////
// WEBPACK FOOTER
// ./node_modules/@coreui/icons/js/free/cil-envelope-open.js
// module id = null
// module chunks = 